import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=6c67b562&scoped=true"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"
import style0 from "./_slug.vue?vue&type=style&index=0&id=6c67b562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c67b562",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShimmerDetailV2: require('/workspace/components/ShimmerDetailV2.vue').default,FaqCardPost: require('/workspace/components/FaqCardPost.vue').default})
